// FTYPE_CODE for SAWT DAT files.
//
// Confirmed by the firm's accountant against a real BIR-accepted sample file:
// FTYPE_CODE is the FILER'S ENTITY TYPE, not a reference to the return the
// SAWT is attached to.
//
//   1701 = individual taxpayer
//   1702 = corporate taxpayer
//
// No "Q" suffix — the sample carries the literal "1702", not "1702Q".
// 2550Q, 2551Q and 2551M are NEVER valid FTYPE_CODE values; the earlier
// assumption that this field mirrored the VAT/percentage-tax return type is
// wrong and has been removed from every exporter.
//
// ReturnFiling.formCode ('2550Q' | '2551Q' | '1701Q' | '1702Q') is a separate
// concern — it tracks the actual quarterly return and must not be conflated
// with this value.

export const FTYPE_INDIVIDUAL = '1701';
export const FTYPE_CORPORATE = '1702';

// AccountingClient.clientType enum: corporation | individual | opc | partnership.
// Only "individual" is a natural person; an OPC is a corporation under the
// Revised Corporation Code and a taxable partnership is taxed as one, so both
// file 1702. (Edge case not expressible in this enum: a general professional
// partnership files 1702-EX. Confirm with the accountant if the firm has one.)
const CORPORATE_CLIENT_TYPES = new Set(['corporation', 'opc', 'partnership']);

/**
 * True when the filer is a juridical entity — drives both the FTYPE_CODE and
 * whether the header carries a registered name or split individual names.
 */
export function isCorporateFiler(clientType) {
  return CORPORATE_CLIENT_TYPES.has(String(clientType || '').toLowerCase());
}

/**
 * Resolve a client's FTYPE_CODE. Returns null for a missing or unrecognized
 * clientType — callers must block the export rather than emit a guess.
 */
export function resolveFtypeCode(clientType) {
  const key = String(clientType || '').toLowerCase();
  if (key === 'individual') return FTYPE_INDIVIDUAL;
  if (CORPORATE_CLIENT_TYPES.has(key)) return FTYPE_CORPORATE;
  return null;
}

/** Blocking-error detail for an unresolvable filer entity type. */
export function missingFtypeMessage(clientName) {
  const who = String(clientName || '').trim() || 'this client';
  return `Cannot determine the entity type for ${who}. Set the client type `
    + '(individual, corporation, OPC or partnership) on the client profile, then export again.';
}
